/**
 * What's On filtering.
 *
 * Progressive enhancement only: every event is already in the HTML and visible
 * before this runs, so if the script fails the list still reads correctly.
 *
 * Supports deep links: /pages/tap-room-page?filter=music
 */

const FILTER_CLASSES = {
  food: 'has-food',
  music: 'has-music',
  tour: 'has-tour',
  sport: 'has-sport',
};

/** Older links used ?filter=rugby, ?filter=6nations, ?filter=streetfood, ?filter=tours */
const LEGACY_FILTERS = {
  rugby: 'sport',
  '6nations': 'sport',
  streetfood: 'food',
  tours: 'tour',
};

function setUp(section) {
  const filterBar = section.querySelector('[data-whats-on-filters]');
  const list = section.querySelector('[data-whats-on-list]');
  if (!filterBar || !list) return;

  const buttons = Array.from(filterBar.querySelectorAll('[data-filter]'));
  const cards = Array.from(list.querySelectorAll('[data-event]'));
  const months = Array.from(list.querySelectorAll('[data-month]'));
  const noResults = section.querySelector('[data-whats-on-no-results]');

  function apply(filter) {
    const className = FILTER_CLASSES[filter];
    let visibleCount = 0;

    cards.forEach((card) => {
      const show = !className || card.classList.contains(className);
      card.hidden = !show;
      if (show) visibleCount += 1;
    });

    // Hide a month heading when nothing under it survived the filter.
    months.forEach((month) => {
      let node = month.nextElementSibling;
      let hasVisible = false;
      while (node && !node.hasAttribute('data-month')) {
        if (node.hasAttribute('data-event') && !node.hidden) {
          hasVisible = true;
          break;
        }
        node = node.nextElementSibling;
      }
      month.hidden = !hasVisible;
    });

    buttons.forEach((button) => {
      const isActive = button.dataset.filter === filter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (noResults) noResults.hidden = visibleCount > 0;
  }

  filterBar.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter]');
    if (!button) return;
    apply(button.dataset.filter);
  });

  const requested = new URLSearchParams(window.location.search).get('filter');
  if (requested) {
    const key = requested.toLowerCase();
    const resolved = FILTER_CLASSES[key] ? key : LEGACY_FILTERS[key];
    if (resolved) apply(resolved);
  }
}

function init(root = document) {
  root.querySelectorAll('[data-section-type="vale-whats-on"]').forEach(setUp);
}

init();

// The theme editor re-renders sections without a full page load.
document.addEventListener('shopify:section:load', (event) => init(event.target));
